import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useEthers } from '@usedapp/core';

import Button from '@bitcoin-portal/verse-web-components/dist/Button';
import Title from '@bitcoin-portal/verse-web-components/dist/Title';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { useDispatch, useTrackedState } from '../../../context/store';

import { StyledImage, TitleWrapper, Wrapper } from './styled';

const NoWallet = () => {
  const dispatch = useDispatch();
  const { isWallet } = useTrackedState();
  const { account, activateBrowserWallet } = useEthers();

  return (
    <Wrapper>
      <StyledImage
        src="/images/uploads/connect-wallet.png"
        alt="Connect wallet"
      />
      <TitleWrapper>
        <Title style={{ color: colors.shade90 }}>
          <FormattedMessage id="lounge.nowallet.title" />
        </Title>
        <Button
          small
          fullWidth
          onClick={() => {
            if (isWallet && !account) {
              activateBrowserWallet({
                type: 'bcomwallet',
              });

              return;
            }

            dispatch({
              type: 'SET_CONNECT_MODAL_OPEN',
              payload: true,
            });
          }}
        >
          <FormattedMessage id="lounge.nowallet.connect" />
        </Button>
      </TitleWrapper>
    </Wrapper>
  );
};

export default NoWallet;
